import React from 'react';
import confetti from 'canvas-confetti';
interface ConfettiButtonProps {
  onConfetti?: () => void;
  children: React.ReactNode;
}
export function triggerConfetti() {
  const duration = 2000;
  const end = Date.now() + duration;
  const frame = () => {
    confetti({
      particleCount: 2,
      angle: 60,
      spread: 55,
      origin: {
        x: 0
      },
      colors: ['#A020F0', '#FFFC00', '#9DC817']
    });
    confetti({
      particleCount: 2,
      angle: 120,
      spread: 55,
      origin: {
        x: 1
      },
      colors: ['#A020F0', '#FFFC00', '#9DC817']
    });
    if (Date.now() < end) {
      requestAnimationFrame(frame);
    }
  };
  frame();
}